import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  CreateTaskComment as CreateTaskCommentGenerated,
  CreateTaskCommentVariables as CreateTaskCommentVariablesGenerated,
} from "core/queries/__generated__/CreateTaskComment";

export interface CreateTaskCommentResponse extends CreateTaskCommentGenerated {}
export interface CreateTaskCommentVariables
  extends CreateTaskCommentVariablesGenerated {}

export const createTaskComment = gql`
  mutation CreateTaskComment(
    $taskId: ID!
    $plainBody: String!
    $htmlBody: String!
    $mentions: [ID!]
    $markAllRead: Boolean
  ) {
    createComment(
      targetType: task
      targetId: $taskId
      body: $plainBody
      richContent: { html: $htmlBody, mentions: $mentions }
      markAllRead: $markAllRead
    ) {
      comment {
        id
      }
    }
  }
`;

interface UseCreateTaskCommentQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
}
export const useCreateTaskComment = ({
  refetchQueries = [],
  awaitRefetchQueries = false,
}: UseCreateTaskCommentQueryOptions) =>
  useMutation<CreateTaskCommentResponse, CreateTaskCommentVariables>(
    createTaskComment,
    { refetchQueries, awaitRefetchQueries },
  );
